









import { Vue, Component, Prop } from 'vue-property-decorator';
import posed, { PoseTransition } from 'vue-pose';

import { baseAnimations } from '@/views/Onboarding/helpers';
import { IBusinessType } from '@/models/business';
import ShieldIcon from '@/components/icons/Shield.vue';

@Component({
  components: {
    PoseTransition,
    Container: posed.div(baseAnimations()),
    ShieldIcon
  }
})
export default class Ilustra extends Vue {
  @Prop() img?: string;

  IBusinessType = IBusinessType;

  get imgUrl() {
    return require(`@/assets/img/reward-modal/${this.img}-ilustra.png`);
  }
}
